import React from "react";
import Badge from "./Badge";
import { formatPercent } from "../utils/numbers";
const PercentBadge = ({ amount, total }) => (
    <Badge margin={{ vertical: 'xxsmall' }}>{formatPercent(total !== 0 ? amount / total : 0)}</Badge>
);

export default PercentBadge;